import { render } from "./message_me.vue?vue&type=template&id=61c025d5&scoped=true"
import script from "./message_me.vue?vue&type=script&lang=js"
export * from "./message_me.vue?vue&type=script&lang=js"

import "./message_me.vue?vue&type=style&index=0&id=61c025d5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61c025d5"

export default script